<template>
  <b-form @submit.prevent="submit" class="flex-center">
    <AuthWrapper
      leftIcon="help-circle-outline"
      :leftIconTooltip="$lang.problem_login_link_caption"
      @handleLeftIcon="goToContactUs"
      rightIcon="arrow-right"
      @handleRightIcon="goBack"
    >
      <template #main>
        <b-row>
          <b-col cols="12" md="12">
            <Otp
              :value="form.code"
              name="code"
              id="code"
              :vuelidateObj="$v.form.code"
              :expireSeconds="EXPIRE_SECONDS"
              :showEdit="true"
              @input="input"
              @resend="goBack"
              @editNumber="goBack"
              @onComplete="submit"
            />
          </b-col>
        </b-row>
      </template>
      <template #button>
        <b-row>
          <b-col cols="12" md="12">
            <Button
              type="submit"
              class="w-100"
              contentClass="justify-content-center"
              variant="primary"
              :text="$lang.submit"
              :loading="loading || registrationCoursesLoading"
              @click="submit"
            />
          </b-col>
        </b-row>
      </template>
    </AuthWrapper>
  </b-form>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { AuthWrapper, Otp } from "@/components/re-design";
import { Button } from "@/components/re-design/forms";
import { required, numeric, minLength } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import { pathOr } from "ramda";

export default {
  inject: ["EXPIRE_SECONDS", "submitVerifyCode", "goToContactUs", "goBack"],
  mixins: [inputMixin],
  components: {
    AuthWrapper,
    Otp,
    Button,
  },
  validations() {
    return {
      form: {
        code: {
          required,
          numeric,
          minLength: minLength(this.codeLength),
        },
      },
    };
  },
  data() {
    return {
      form: {
        code: null,
      },
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["registrationCoursesLoading"]),
  },
  methods: {
    pathOr,
    async submit() {
      this.$v.$touch();
      if (this.$v.$anyError || this.loading) return;

      try {
        this.loading = true;
        await this.submitVerifyCode(this.form.code);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
